import _ from "lodash";
import React from "react";
import classNames from "classnames";
import {
  FilterLabelButton,
  ChecklistDropdown,
  Button,
  Badge,
} from "@toddle-edu/ds-web";
import {
  ClassChannelOutlined,
  CustomChannelOutlined,
  FamilyChannelOutlined,
  HashtagOutlined,
  FilterOutlined,
} from "@toddle-edu/ds-icons";
import { connect } from "react-redux";

import { useI18n } from "Hooks";
import { getLabelValueForMultiFilterLabelButton } from "Utils";
import {
  CHANNEL_TYPES,
  isMessagingRevempEnabled,
} from "MessagingV2/modules/Utils";

import classes from "./ChannelTypeFilter.scss";
import { getUserType } from "modules/CommonSelectors";
import { PARENT, STUDENT } from "Constants/stringConstants";

const getOptions = ({ t, loggedInUserType }) => {
  const dropdownOverlayOptions = [
    {
      value: "DIVIDER",
      isDivider: true,
      isHidden: false,
    },
    {
      value: CHANNEL_TYPES.CHANNEL_SYSTEM_MANAGED,
      label: t("common:class_channel"),
      isHidden: loggedInUserType === PARENT,
      prefixElement: (
        <ClassChannelOutlined variant={"subtle"} size={"xx-small"} />
      ),
    },
    {
      value: CHANNEL_TYPES.CHANNEL_CUSTOM,
      label: t("common:custom_channel"),
      isHidden: false,
      prefixElement: (
        <CustomChannelOutlined variant={"subtle"} size={"xx-small"} />
      ),
    },
    {
      value: CHANNEL_TYPES.CHANNEL_FAMILY,
      label: t("common:family_channel"),
      isHidden: loggedInUserType === STUDENT,
      prefixElement: (
        <FamilyChannelOutlined variant={"subtle"} size={"xx-small"} />
      ),
    },
  ];

  return _.filter(dropdownOverlayOptions, option => !option.isHidden);
};

const ChannelTypeFilter = ({ onOptionsSelected, value, loggedInUserType }) => {
  const { t } = useI18n(["common"]);
  const dropdownOverlayOptions = getOptions({ t, loggedInUserType });

  return (
    <div className={classes.filterContainer}>
      <ChecklistDropdown
        allOptionPrefix={<HashtagOutlined size={"xx-small"} variant="subtle" />}
        allOptionLabel={t("common:all")}
        options={dropdownOverlayOptions}
        showAllOption
        value={value}
        onChange={onOptionsSelected}
        showSelectedOptionsOnTop={false}
        checklistContainerClassName={classes.dropDownClass}
      >
        {isMessagingRevempEnabled() ? (
          <Button
            icon={<FilterOutlined />}
            size="small"
            variant="neutral"
            type="outlined"
            className={classNames(classes.filterButton, {
              [classes.filterButtonWithBadge]: _.size(value),
            })}
            dsVersion="2.0"
          >
            {_.size(value) ? (
              <Badge type="numeric" value={_.size(value)} variant={"filter"} />
            ) : null}
          </Button>
        ) : (
          <FilterLabelButton
            size="medium"
            variant="inline"
            label={t("common:channel_type")}
            labelValue={getLabelValueForMultiFilterLabelButton({
              t,
              selectedOptions: value,
              options: dropdownOverlayOptions,
              noneText: t("common:all"),
            })}
          />
        )}
      </ChecklistDropdown>
    </div>
  );
};

const mapStateToProps = state => ({
  loggedInUserType: getUserType(state),
});

export default connect(mapStateToProps)(ChannelTypeFilter);
